import { render, staticRenderFns } from "./_TabInfosGenerales.vue?vue&type=template&id=6b75eda6&"
import script from "./_TabInfosGenerales.vue?vue&type=script&lang=ts&"
export * from "./_TabInfosGenerales.vue?vue&type=script&lang=ts&"
import style0 from "./_TabInfosGenerales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports